export const REDO_API_URL = process.env.REDO_API_URL || "http://localhost:8888";

export const REDO_MARKETPLACE_APP_VERSION =
  process.env.REDO_MARKETPLACE_APP_VERSION || "_";

export const REDO_MARKETPLACE_SERVER_URL =
  process.env.REDO_MARKETPLACE_SERVER_URL || "http://localhost:8018";

export const DATADOG_APPLICATION_ID =
  process.env.DATADOG_APPLICATION_ID ?? null;
export const DATADOG_CLIENT_TOKEN = process.env.DATADOG_CLIENT_TOKEN ?? null;
